
import BusinessContact from '@/components/company/BusinessContact';
import CompanyInfo from '@/components/company/CompanyInfo';
import OperationContact from '@/components/company/OperationContact';
import DefaultSetting from '@/components/default/DefaultSetting';
import DomainWhiteList from '@/components/default/DomainWhiteList';
import Integrations from '@/components/company/integrations.vue';
// import PlanDetails from '@/components/company/PlanDetails.vue';
export default {
  components: {
    // PlanDetails,
    BusinessContact,
    CompanyInfo,
    OperationContact,
    DefaultSetting,
    DomainWhiteList
  },
  data() {
    return {
      tabs: 'companyInfo'
    };
  }
};
